export default {
  namespaced: true,
  state: {
    errors: [],
    showErros: false
  },
  getters: {},
  mutations: {
    SET_ERROR_PART (state, { id, subtable, data, message, name }) {
      if (!state.errors[subtable]) state.errors[subtable] = {}
      if (!state.errors[subtable][id]) state.errors[subtable][id] = {}
      state.errors[subtable][id].rowIndex = data.rowIndex
      state.errors[subtable][id][data.type] = {
        index: data.index,
        colIndex: data.colIndex,
        rowIndex: data.rowIndex,
        message: message,
        name: name
      }
    },
    DEL_ERROR_PART (state, { id, subtable, data }) {
      if (state.errors[subtable]?.[id]) {
        if (state.errors[subtable][id][data.type]) delete state.errors[subtable][id][data.type]
        if (Object.keys(state.errors[subtable][id]).length === 1) {
          delete state.errors[subtable][id]
        }
      }
    },
    DEL_ALL_ERROR (state) {
      state.errors = []
    }
  },
  actions: {
    delAllErrors ({ rootState, commit }) {
      commit('DEL_ALL_ERROR')
      rootState.partsErrors.showErros = false
    },
    validateParts ({ state, rootState, commit }, subtable) {
      if (rootState.parts.changedImages[subtable]) {
        for (const key in rootState.parts.changedImages[subtable]) {
          commit('DEL_ERROR_PART', {
            id: rootState.parts.changedImages[subtable][key].part_id,
            subtable: subtable,
            data: {
              type: 'image_valid' + key,
              index: rootState.parts.changedImages[subtable][key].index,
              colIndex: rootState.parts.changedImages[subtable][key].colIndex,
              rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
            }
          })
          // required params
          if (
            (
              rootState.parts.changedImages[subtable][key].reqiured_params?.length > 0 &&
              !rootState.parts.changedImages[subtable][key].isUpdate
            ) ||
            (
              rootState.parts.changedImages[subtable][key].isUpdate &&
              rootState.parts.changedImages[subtable][key].data.params &&
              rootState.parts.changedImages[subtable][key].reqiured_params?.length > 0
            )
          ) {
            if (!rootState.parts.changedImages[subtable][key].data.params) {
              commit('SET_ERROR_PART', {
                id: rootState.parts.changedImages[subtable][key].part_id,
                subtable: subtable,
                data: {
                  type: 'image_valid' + key,
                  index: rootState.parts.changedImages[subtable][key].index,
                  colIndex: rootState.parts.changedImages[subtable][key].colIndex,
                  rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
                },
                message: `
                  required params
                  ${rootState.parts.changedImages[subtable][key].reqiured_params.join(', ')}
                `,
                name: rootState.parts.changedImages[subtable][key].name
              })
            } else {
              rootState.parts.changedImages[subtable][key].reqiured_params.forEach(el => {
                if (
                  !Object.keys(rootState.parts.changedImages[subtable][key].data.params).includes(el)
                ) {
                  commit('SET_ERROR_PART', {
                    id: rootState.parts.changedImages[subtable][key].part_id,
                    subtable: subtable,
                    data: {
                      type: 'image_valid' + key,
                      index: rootState.parts.changedImages[subtable][key].index,
                      colIndex: rootState.parts.changedImages[subtable][key].colIndex,
                      rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
                    },
                    message: `required params ${el}`,
                    name: rootState.parts.changedImages[subtable][key].name
                  })
                }
              })
            }
          }
          // allParams
          if (
            rootState.parts.changedImages[subtable][key].all_params?.length &&
            rootState.parts.changedImages[subtable][key].data.params
          ) {
            const paramArray = Object.keys(rootState.parts.changedImages[subtable][key].data.params)
            const filterPar = paramArray.filter(par => {
              if (!rootState.parts.changedImages[subtable][key].all_params.includes(par)) return par
              else return null
            })
            if (filterPar.length) {
              commit('SET_ERROR_PART', {
                id: rootState.parts.changedImages[subtable][key].part_id,
                subtable: subtable,
                data: {
                  type: 'image_valid' + key,
                  index: rootState.parts.changedImages[subtable][key].index,
                  colIndex: rootState.parts.changedImages[subtable][key].colIndex,
                  rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
                },
                message: `
                  You can only add params:
                  ${rootState.parts.changedImages[subtable][key].all_params.join(', ')}
                `,
                name: rootState.parts.changedImages[subtable][key].name
              })
            }
          }
          // required attrs
          if (
            (
              rootState.parts.changedImages[subtable][key].reqiured_attrs?.length > 0 &&
              !rootState.parts.changedImages[subtable][key].isUpdate
            ) ||
            (
              rootState.parts.changedImages[subtable][key].isUpdate &&
              rootState.parts.changedImages[subtable][key].attrs &&
              rootState.parts.changedImages[subtable][key].reqiured_attrs?.length > 0
            )
          ) {
            if (!rootState.parts.changedImages[subtable][key]?.attrs?.length) {
              commit('SET_ERROR_PART', {
                id: rootState.parts.changedImages[subtable][key].part_id,
                subtable: subtable,
                data: {
                  type: 'image_valid' + key,
                  index: rootState.parts.changedImages[subtable][key].index,
                  colIndex: rootState.parts.changedImages[subtable][key].colIndex,
                  rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
                },
                message: `
                  required attrs
                  ${rootState.parts.changedImages[subtable][key].reqiured_attrs.join(', ')}
                `,
                name: rootState.parts.changedImages[subtable][key].name
              })
            } else {
              rootState.parts.changedImages[subtable][key].reqiured_attrs.forEach(reqiured => {
                const hasAttr = rootState.parts.changedImages[subtable][key].attrs.find(el => el.type === reqiured)
                if (!hasAttr) {
                  commit('SET_ERROR_PART', {
                    id: rootState.parts.changedImages[subtable][key].part_id,
                    subtable: subtable,
                    data: {
                      type: 'image_valid' + key,
                      index: rootState.parts.changedImages[subtable][key].index,
                      colIndex: rootState.parts.changedImages[subtable][key].colIndex,
                      rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
                    },
                    message: `
                      required attrs
                      ${rootState.parts.changedImages[subtable][key].reqiured_attrs.join(', ')}
                    `,
                    name: rootState.parts.changedImages[subtable][key].name
                  })
                }
              })
            }
          }
          // allAttr
          if (
            rootState.parts.changedImages[subtable][key].all_attrs?.length &&
            rootState.parts.changedImages[subtable][key].attrs
          ) {
            const filterAttr = rootState.parts.changedImages[subtable][key].attrs.filter(attr => {
              if (!rootState.parts.changedImages[subtable][key].all_attrs.includes(attr.type)) return attr
              else return null
            })
            if (filterAttr.length) {
              commit('SET_ERROR_PART', {
                id: rootState.parts.changedImages[subtable][key].part_id,
                subtable: subtable,
                data: {
                  type: 'image_valid' + key,
                  index: rootState.parts.changedImages[subtable][key].index,
                  colIndex: rootState.parts.changedImages[subtable][key].colIndex,
                  rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
                },
                message: `
                  You can only add attrs:
                  ${rootState.parts.changedImages[subtable][key].all_attrs.join(', ')}
                `,
                name: rootState.parts.changedImages[subtable][key].name
              })
            }
          }
          const types = rootState.parts.data[subtable].columns.filter(el => {
            if (el.sides) {
              return el.category === 'children' && el.type === rootState.parts.changedImages[subtable][key].type && !el.sides.includes(rootState.parts.changedImages[subtable][key].side)
            } else return el.category === 'children' && el.type === rootState.parts.changedImages[subtable][key].type && el.side !== rootState.parts.changedImages[subtable][key].side
          })
          if (
            types.length > 0 &&
            !rootState.parts.changedImages[subtable][key].pair &&
            !key.includes('new') &&
            (
              !rootState.parts.changedImages[subtable][key].isUpdate ||
              (
                rootState.parts.changedImages[subtable][key].isUpdate &&
                (
                  rootState.parts.changedImages[subtable][key].data.params ||
                  rootState.parts.changedImages[subtable][key].attrs
                )
              )
            )
          ) {
            const allArrayKeys = Object.keys(rootState.parts.changedImages[subtable])
            const imgPair = allArrayKeys.filter(el => {
              const img = rootState.parts.changedImages[subtable][key]
              const filterimg = rootState.parts.changedImages[subtable][el]
              let paramOk = false
              let algOk = false
              let attrOk = false
              if (
                JSON.stringify(filterimg.data.params) === JSON.stringify(img.data.params) &&
                JSON.stringify(filterimg.oldParams) === JSON.stringify(img.oldParams)
              ) {
                paramOk = true
              }
              if (img.alg === filterimg.alg) algOk = true
              const imgAttr = img.data.attributes
              const filterAttr = filterimg.data.attributes
              if (imgAttr && filterAttr) {
                const isEqual = imgAttr.length === filterAttr.length && filterAttr.filter(value => imgAttr.includes(value))
                if (isEqual && isEqual.length === imgAttr.length) attrOk = true
              } else if (!imgAttr && !filterAttr) attrOk = true
              if (paramOk && algOk && attrOk && img.side !== filterimg.side) {
                filterimg.pair = key
                img.pair = el
                return el
              } else return null
            })
            if (imgPair.length === 0) {
              let attrText = ''
              if (rootState.parts.changedImages[subtable][key].attrs) {
                const filterAttrName = rootState.parts.changedImages[subtable][key].attrs.map(attr => {
                  return attr.name
                })
                attrText = 'with attributes ' + filterAttrName.join()
              }
              let paramText = ''
              if (rootState.parts.changedImages[subtable][key].data.params) {
                for (const par in rootState.parts.changedImages[subtable][key].data.params) {
                  const parValue = rootState.parts.changedImages[subtable][key].data.params[par]
                  if (Number(par)) {
                    paramText = `${paramText} par${par}:${parValue}`
                  } else paramText = `${paramText} ${par}:${parValue}`
                }
              }
              commit('SET_ERROR_PART', {
                id: rootState.parts.changedImages[subtable][key].part_id,
                subtable: subtable,
                data: {
                  type: 'image_valid' + key,
                  index: rootState.parts.changedImages[subtable][key].index,
                  colIndex: rootState.parts.changedImages[subtable][key].colIndex,
                  rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
                },
                message: `
                  image
                  ${paramText ? `with ${paramText},` : ''}
                  ${attrText ? attrText + ',' : ''}
                  ${
                    rootState.parts.changedImages[subtable][key].data.alg
                      ? 'with algorithm' + rootState.parts.changedImages[subtable][key].data.alg + ','
                      : ''
                  }
                  doesn't have matching
                  ${rootState.parts.changedImages[subtable][key].side === 'front' ? 'back' : 'front'}
                `,
                name: rootState.parts.changedImages[subtable][key].name
              })
            }
          }
          if (types.length > 0 && !rootState.parts.changedImages[subtable][key].pair && key.includes('new')) {
            const keyArray = key.split('_')
            const allArrayKeys = Object.keys(rootState.parts.changedImages[subtable])
            const needArrayKeys = allArrayKeys.filter(el => el.includes(`${keyArray[0]}_${keyArray[1] === 'front' ? 'back' : 'front'}_${keyArray[2]}_${keyArray[3]}`))
            if (needArrayKeys.length === 0) {
              let attrText = ''
              if (rootState.parts.changedImages[subtable][key].attrs) {
                const filterAttrName = rootState.parts.changedImages[subtable][key].attrs.map(attr => {
                  return attr.name
                })
                attrText = 'with attributes ' + filterAttrName.join()
              }
              let paramText = ''
              if (rootState.parts.changedImages[subtable][key].data.params) {
                for (const par in rootState.parts.changedImages[subtable][key].data.params) {
                  const parValue = rootState.parts.changedImages[subtable][key].data.params[par]
                  if (Number(par)) {
                    paramText = `${paramText} par${par}:${parValue}`
                  } else paramText = `${paramText} ${par}:${parValue}`
                }
              }
              commit('SET_ERROR_PART', {
                id: rootState.parts.changedImages[subtable][key].part_id,
                subtable: subtable,
                data: {
                  type: 'image_valid' + key,
                  index: rootState.parts.changedImages[subtable][key].index,
                  colIndex: rootState.parts.changedImages[subtable][key].colIndex,
                  rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
                },
                message: `
                  image
                  ${paramText ? `with ${paramText},` : ''}
                  ${attrText ? attrText + ',' : ''}
                  ${
                    rootState.parts.changedImages[subtable][key].data.alg
                      ? 'with algorithm' + rootState.parts.changedImages[subtable][key].data.alg + ','
                      : ''
                  }
                  doesn't have matching
                  ${rootState.parts.changedImages[subtable][key].side === 'front' ? 'back' : 'front'}
                `,
                name: rootState.parts.changedImages[subtable][key].name
              })
            } else {
              const dataImg = rootState.parts.changedImages[subtable][key].data
              const imgPair = needArrayKeys.filter(el => {
                let paramOk = false
                let algOk = false
                let attrOk = false
                if (dataImg.params && rootState.parts.changedImages[subtable][el].data.params) {
                  if (JSON.stringify(dataImg.params) === JSON.stringify(rootState.parts.changedImages[subtable][el].data.params)) {
                    paramOk = true
                  }
                } else if (!dataImg.params && !rootState.parts.changedImages[subtable][el].data.params) paramOk = true
                if (dataImg.alg === rootState.parts.changedImages[subtable][el].data.alg) {
                  algOk = true
                }
                if (dataImg.attributes && rootState.parts.changedImages[subtable][el].data.attributes) {
                  const isEqual = dataImg.attributes.length === rootState.parts.changedImages[subtable][el].data.attributes.length &&
                    dataImg.attributes.filter(value => rootState.parts.changedImages[subtable][el].data.attributes.includes(value))
                  if (isEqual && isEqual.length === dataImg.attributes.length) attrOk = true
                } else if (!dataImg.attributes && !rootState.parts.changedImages[subtable][el].data.attributes) attrOk = true
                if (paramOk && algOk && attrOk) {
                  rootState.parts.changedImages[subtable][key].pair = el
                  rootState.parts.changedImages[subtable][el].pair = key
                  return el
                } else return null
              })
              if (imgPair.length === 0) {
                let attrText = ''
                if (rootState.parts.changedImages[subtable][key].attrs) {
                  const filterAttrName = rootState.parts.changedImages[subtable][key].attrs.map(attr => {
                    return attr.name
                  })
                  attrText = 'with attributes ' + filterAttrName.join()
                }
                let paramText = ''
                if (rootState.parts.changedImages[subtable][key].data.params) {
                  for (const par in rootState.parts.changedImages[subtable][key].data.params) {
                    const parValue = rootState.parts.changedImages[subtable][key].data.params[par]
                    if (Number(par)) {
                      paramText = `${paramText} par${par}:${parValue}`
                    } else paramText = `${paramText} ${par}:${parValue}`
                  }
                }
                commit('SET_ERROR_PART', {
                  id: rootState.parts.changedImages[subtable][key].part_id,
                  subtable: subtable,
                  data: {
                    type: 'image_valid' + key,
                    index: rootState.parts.changedImages[subtable][key].index,
                    colIndex: rootState.parts.changedImages[subtable][key].colIndex,
                    rowIndex: rootState.parts.changedImages[subtable][key].rowIndex
                  },
                  message: `
                    image
                    ${paramText ? `with ${paramText},` : ''}
                    ${attrText ? attrText + ',' : ''}
                    ${
                      rootState.parts.changedImages[subtable][key].data.alg
                      ? 'with algorithm' + rootState.parts.changedImages[subtable][key].data.alg + ','
                      : ''
                    }
                    doesn't have matching
                    ${rootState.parts.changedImages[subtable][key].side === 'front' ? 'back' : 'front'}
                  `,
                  name: rootState.parts.changedImages[subtable][key].name
                })
              }
            }
          }
        }
      }
      for (const key in rootState.parts.changedParts[subtable]) {
        if (key.includes('copy') || key.includes('new')) {
          const part = rootState.parts.data[subtable].parts.find(el => {
            return el.name === 'id' && el.data === key
          })
          if (!rootState.parts.changedParts[subtable][key].data.image_ids) {
            const types = rootState.parts.data[subtable].columns.filter(el => {
              return el.category === 'children' || el.category === 'image'
            })
            const imagesArray = Object.keys(rootState.parts.changedImages[subtable] || {})
            types.forEach(el => {
              const id = `new_${el.side || el.sides[0]}_${el.type}_${key}_0`
              if (!imagesArray.includes(id) && !el.optional) {
                commit('SET_ERROR_PART', {
                  id: key,
                  subtable: subtable,
                  data: {
                    type: 'image' + id,
                    index: rootState.parts.data[subtable].totalCols * part.rowIndex + el.colIndex,
                    colIndex: el.colIndex,
                    rowIndex: part.rowIndex
                  },
                  message: 'field is required',
                  name: el.name
                })
              } else {
                commit('DEL_ERROR_PART', {
                  id: key,
                  subtable: subtable,
                  data: {
                    type: 'image' + id,
                    index: rootState.parts.data[subtable].totalCols * part.rowIndex + el.colIndex,
                    colIndex: el.colIndex,
                    rowIndex: part.rowIndex
                  }
                })
              }
            })
          }
          if (Object.keys(rootState.parts.changedParts[subtable][key].allData).length === 0) {
            commit('SET_ERROR_PART', {
              id: key,
              subtable: subtable,
              data: {
                type: part.id,
                index: part.index,
                colIndex: part.colIndex,
                rowIndex: part.rowIndex
              },
              message: 'no change in copied line',
              name: key
            })
          } else {
            commit('DEL_ERROR_PART', {
              id: key,
              subtable: subtable,
              data: {
                type: part.id,
                index: part.index,
                colIndex: part.colIndex,
                rowIndex: part.rowIndex
              }
            })
          }
        }
        for (const i in rootState.parts.changedParts[subtable][key].allData) {
          if (i === 'delete_image_ids') {
            rootState.parts.changedParts[subtable][key].allData[i].forEach(img => {
              commit('DEL_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: {
                  type: img.id,
                  index: img.data.index,
                  colIndex: img.data.colIndex,
                  rowIndex: img.data.rowIndex
                }
              })
              const types = rootState.parts.data[subtable].columns.filter(el => {
                if (el.sides) {
                  return el.category === 'children' && el.type === img.type && !el.sides.includes(img.side)
                } else return el.category === 'children' && el.type === img.type && el.side !== img.side
              })
              if (types.length > 0 && !img.pair) {
                const imgPair = rootState.parts.changedParts[subtable][key].allData[i].filter(el => {
                  let paramOk = false
                  let algOk = false
                  let attrOk = false
                  if (JSON.stringify(el.params) === JSON.stringify(img.params)) paramOk = true
                  if (img.alg === el.alg) algOk = true
                  const attr = []
                  img.attrs.forEach(el => attr.push(el.id))
                  if (img.attrs && el.attrs) {
                    const isEqual = attr.length === el.attrs.length && el.attrs.filter(value => attr.includes(value.id))
                    if (isEqual && isEqual.length === img.attrs.length) attrOk = true
                  } else if (!img.attrs && !el.attrs) attrOk = true
                  if (paramOk && algOk && attrOk && img.side !== el.side) {
                    el.pair = img.id
                    img.pair = el.id
                    return el
                  } else return null
                })
                if (imgPair.length === 0) {
                  commit('SET_ERROR_PART', {
                    id: key,
                    subtable: subtable,
                    data: {
                      type: img.id,
                      index: img.data.index,
                      colIndex: img.data.colIndex,
                      rowIndex: img.data.rowIndex
                    },
                    message: 'Remove pair for picture',
                    name: 'children'
                  })
                }
              }
            })
          }
          if (
            rootState.parts.changedParts[subtable][key].allData[i].category === 'allowedparams' &&
            !rootState.parts.changedParts[subtable][key].allData[i].optional
          ) {
            let isSelect = null
            for (const allowed in rootState.parts.changedParts[subtable][key].allData[i].data) {
              if (rootState.parts.changedParts[subtable][key].allData[i].data[allowed].selected.length > 0) {
                isSelect = true
              }
            }
            if (!isSelect) {
              commit('SET_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: rootState.parts.changedParts[subtable][key].allData[i],
                message: 'Required field',
                name: rootState.parts.changedParts[subtable][key].allData[i].name
              })
            } else {
              commit('DEL_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: rootState.parts.changedParts[subtable][key].allData[i]
              })
            }
          }
          if (rootState.parts.changedParts[subtable][key].allData[i].category === 'field') {
            if (
              rootState.parts.changedParts[subtable][key].allData[i].data.length === 0 &&
              !rootState.parts.changedParts[subtable][key].allData[i].optional
            ) {
              commit('SET_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: rootState.parts.changedParts[subtable][key].allData[i],
                message: 'Required field',
                name: rootState.parts.changedParts[subtable][key].allData[i].name
              })
            } else if (rootState.parts.changedParts[subtable][key].allData[i].data.length < 3) {
              commit('SET_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: rootState.parts.changedParts[subtable][key].allData[i],
                message: 'String must be greater than 2',
                name: rootState.parts.changedParts[subtable][key].allData[i].name
              })
            } else {
              commit('DEL_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: rootState.parts.changedParts[subtable][key].allData[i]
              })
            }
          }
          if (i === 'attr') {
            for (const attr in rootState.parts.changedParts[subtable][key].allData[i]) {
              if (
                rootState.parts.changedParts[subtable][key].allData[i][attr].data.length === 0 &&
                !rootState.parts.changedParts[subtable][key].allData[i][attr].optional
              ) {
                commit('SET_ERROR_PART', {
                  id: key,
                  subtable: subtable,
                  data: rootState.parts.changedParts[subtable][key].allData[i][attr],
                  message: 'Required field',
                  name: rootState.parts.changedParts[subtable][key].allData[i][attr].name
                })
              } else {
                commit('DEL_ERROR_PART', {
                  id: key,
                  subtable: subtable,
                  data: rootState.parts.changedParts[subtable][key].allData[i][attr]
                })
              }
            }
          }
          if (rootState.parts.changedParts[subtable][key].allData[i].category === 'params') {
            if (
              !Object.keys(rootState.parts.changedParts[subtable][key].allData[i].data).length &&
              !rootState.parts.changedParts[subtable][key].allData[i].optional
            ) {
              commit('SET_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: rootState.parts.changedParts[subtable][key].allData[i],
                message: 'Required field',
                name: rootState.parts.changedParts[subtable][key].allData[i].name
              })
            } else {
              commit('DEL_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: rootState.parts.changedParts[subtable][key].allData[i]
              })
            }
          }
          if (rootState.parts.changedParts[subtable][key].allData[i].category === 'fieldsArray') {
            if (rootState.parts.changedParts[subtable][key].allData[i].data.length > 0) {
              const errors = []
              rootState.parts.changedParts[subtable][key].allData[i].data.forEach((el, index) => {
                const regex = /^[A-Z]{1,}[0-9]{1,}$/g
                const found = regex.test(el)
                if (!el) {
                  commit('SET_ERROR_PART', {
                    id: key,
                    subtable: subtable,
                    data: rootState.parts.changedParts[subtable][key].allData[i],
                    message: 'Value cannot be empty',
                    name: rootState.parts.changedParts[subtable][key].allData[i].name
                  })
                  errors.push(index)
                } else if (!found) {
                  commit('SET_ERROR_PART', {
                    id: key,
                    subtable: subtable,
                    data: rootState.parts.changedParts[subtable][key].allData[i],
                    message: 'At least 1 capital letter and 1 number',
                    name: rootState.parts.changedParts[subtable][key].allData[i].name
                  })
                  errors.push(index)
                }
              })
              if (errors.length === 0) {
                commit('DEL_ERROR_PART', {
                  id: key,
                  subtable: subtable,
                  data: rootState.parts.changedParts[subtable][key].allData[i]
                })
              }
            } else if (
              rootState.parts.changedParts[subtable][key].allData[i].data.length === 0 &&
              !rootState.parts.changedParts[subtable][key].allData[i].optional
            ) {
              commit('SET_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: rootState.parts.changedParts[subtable][key].allData[i],
                message: 'Required field',
                name: rootState.parts.changedParts[subtable][key].allData[i].name
              })
            } else {
              commit('DEL_ERROR_PART', {
                id: key,
                subtable: subtable,
                data: rootState.parts.changedParts[subtable][key].allData[i]
              })
            }
          }
        }
      }
    }
  }
}
